import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";

const ProgramPage: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  // --- DATA KONTEN ---
  const programData = [
    {
      title: "Program Overview",
      content:
        "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua. Ut Enim Ad Minim Veniam, Quis Nostrud Exercitation Ullamco Laboris Nisi Ut Aliquip Ex Ea Commodo Consequat. Duis Aute Irure Dolor In Reprehenderit In Voluptate Velit Esse Cillum Dolore Eu Fugiat Nulla Pariatur.",
    },
    {
      title: "What You’ll Learn",
      content:
        "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua. Ut Enim Ad Minim Veniam, Quis Nostrud Exercitation Ullamco Laboris Nisi Ut Aliquip Ex Ea Commodo Consequat. Duis Aute Irure Dolor In Reprehenderit In Voluptate Velit Esse Cillum Dolore Eu Fugiat Nulla Pariatur.",
    },
    {
      title: "What You’ll Learn",
      content:
        "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua. Ut Enim Ad Minim Veniam, Quis Nostrud Exercitation Ullamco Laboris Nisi Ut Aliquip Ex Ea Commodo Consequat. Duis Aute Irure Dolor In Reprehenderit In Voluptate Velit Esse Cillum Dolore Eu Fugiat Nulla Pariatur.",
    },
    {
      title: "What You’ll Learn",
      content:
        "Lorem Ipsum Dolor Sit Amet, Consectetur Adipiscing Elit, Sed Do Eiusmod Tempor Incididunt Ut Labore Et Dolore Magna Aliqua. Ut Enim Ad Minim Veniam, Quis Nostrud Exercitation Ullamco Laboris Nisi Ut Aliquip Ex Ea Commodo Consequat. Duis Aute Irure Dolor In Reprehenderit In Voluptate Velit Esse Cillum Dolore Eu Fugiat Nulla Pariatur.",
    },
  ];

  return (
    <div className="relative w-full min-h-screen bg-[#FAFAFA] font-sans overflow-x-hidden">
      {/* =========================================
          1. BACKGROUND LAYER (PINK)
          ========================================= */}
      {/* UPDATE: Tinggi diperpendek lagi ke 280px (Mobile) & 320px (Desktop).
          Background sekarang sangat ringkas. */}
      <div className="absolute top-0 left-0 w-full h-[280px] md:h-[320px] bg-[#FFEBEB] z-0">
        {/* Pola Background */}
        <div
          className="absolute inset-0 opacity-40"
          style={{
            backgroundImage: "url('/pattern-bg.png')",
            backgroundRepeat: "repeat",
            backgroundSize: "300px",
            maskImage:
              "linear-gradient(to bottom, black 40%, transparent 100%)",
            WebkitMaskImage:
              "linear-gradient(to bottom, black 40%, transparent 100%)",
          }}
        ></div>

        {/* Dekorasi Garis Kanan */}
        <img
          src="/garis.png"
          alt="Decoration"
          className="absolute top-0 right-0 h-full object-cover opacity-90 pointer-events-none"
        />
      </div>

      {/* =========================================
          2. MAIN CONTENT (GRID LAYOUT)
          ========================================= */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 pt-8 md:pt-14 pb-24">
        {/* GRID SYSTEM */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          {/* --- KOLOM KIRI (HEADER + BODY TEXT) --- */}
          <div className="lg:col-span-8 space-y-12">
            {/* A. Bagian Header (Hero) */}
            <div data-aos="fade-right">
              {/* --- UPDATE: Breadcrumb dengan Link --- */}
              <div className="flex items-center space-x-2 text-red-600 font-medium text-sm md:text-base mb-3">
                <Link
                  to="/"
                  className="hover:underline cursor-pointer transition-colors"
                >
                  Home
                </Link>
                <span>▸</span>
                <Link
                  to="/program-selection"
                  className="hover:underline cursor-pointer transition-colors"
                >
                  Program
                </Link>
                <span>▸</span>
                <span className="text-gray-800">Basic</span>
              </div>
              {/* ----------------------------------- */}

              <h1 className="text-4xl md:text-6xl font-extrabold text-black leading-tight tracking-tight mb-3">
                Basic Program
              </h1>

              <p className="text-lg md:text-xl text-gray-800 font-medium mb-6">
                A Beginner-Friendly Indonesian Learning Program
              </p>

              <a
                href="https://api.whatsapp.com/send/?phone=6282324433012&text&type=phone_number&app_absent=0"
                className="bg-[#FF0000] hover:bg-[#D6001C] text-white font-bold py-3 px-8 rounded-lg shadow-md transition-transform duration-300 transform hover:scale-105"
              >
                Start Learning!
              </a>
            </div>

            {/* B. Bagian Body (Content Loop) */}
            {/* Padding top (pt) ditambahkan agar ada jarak pasca background pink habis */}
            <div className="space-y-12 pt-10">
              {programData.map((item, index) => (
                <div
                  key={index}
                  data-aos="fade-up"
                  data-aos-delay={index * 100}
                >
                  <h3 className="text-2xl md:text-3xl font-bold text-black mb-4">
                    {item.title}
                  </h3>
                  <p className="text-base md:text-lg text-gray-700 leading-relaxed text-justify">
                    {item.content}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* --- KOLOM KANAN (CARD FLOATING) --- */}
          <div className="lg:col-span-4 lg:pt-8 relative" data-aos="fade-left">
            <div className="bg-white rounded-3xl shadow-2xl p-6 w-full border border-gray-100 sticky top-8">
              {/* Gambar Card */}
              <div className="w-full h-48 bg-[#FF0000] rounded-2xl mb-6 shadow-inner flex items-center justify-center">
                {/* Area Gambar */}
              </div>

              <div className="space-y-5 mb-8">
                {/* Harga */}
                <div className="flex items-center space-x-3">
                  <IconWallet />
                  <span className="text-black text-lg font-bold">
                    Rp2.000.000
                  </span>
                </div>
                {/* Rating */}
                <div className="flex items-center space-x-3">
                  <IconStar />
                  <span className="text-black text-lg font-medium">
                    4.6 / 5.0
                  </span>
                </div>
                {/* Learners */}
                <div className="flex items-center space-x-3">
                  <IconUsers />
                  <span className="text-black text-lg font-medium">
                    532 Learners Enrolled
                  </span>
                </div>
                {/* Duration */}
                <div className="flex items-center space-x-3">
                  <IconClock />
                  <span className="text-black text-lg font-medium">
                    4-Week Program
                  </span>
                </div>
              </div>

              <a
                href="https://api.whatsapp.com/send/?phone=6282324433012&text&type=phone_number&app_absent=0"
                target="_blank"
                rel="noopener noreferrer"
              >
                <button className="w-full bg-[#FF0000] hover:bg-[#D6001C] text-white font-bold py-3 px-4 rounded-xl shadow-md transition-all duration-300 transform hover:scale-[1.02]">
                  Start Learning!
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// --- KOMPONEN IKON ---
const IconWallet = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-gray-700"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
    />
  </svg>
);
const IconStar = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-gray-700"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
    />
  </svg>
);
const IconUsers = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-gray-700"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
    />
  </svg>
);
const IconClock = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6 text-gray-700"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={1.5}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
    />
  </svg>
);

export default ProgramPage;
